import { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { statusChecksMutationKeys } from 'queries/status-checks/query-keys'
import { type MultiValueTags } from 'types/tags'

function putStatusCheckTags(
  mutationKey?: ReturnType<
    typeof statusChecksMutationKeys.mutateStatusCheckTags
  >
) {
  return async (payload: MultiValueTags) => {
    if (!mutationKey)
      throw new AxiosError(
        'Cannot udpate status check tags without a status check ID'
      )

    const endpointWithParams = getEndpointWithParams(...mutationKey)
    const response = await agent.put<string>(endpointWithParams, payload)

    return response.data
  }
}

export function usePutStatusCheckTags(
  statusCheckId?: string,
  options?: Omit<
    UseMutationOptions<string, AxiosError, MultiValueTags>,
    'mutationKey' | 'mutationFn'
  >
) {
  const { currentTeamId } = useAuth()
  const mutationKey = statusCheckId
    ? statusChecksMutationKeys.mutateStatusCheckTags({
        statusCheckId,
        teamId: currentTeamId
      })
    : undefined

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: putStatusCheckTags(mutationKey)
  })
}
